import { Box, Grid, List, Paper, Typography } from '@mui/material'

import { useTranslation } from 'react-i18next'
import { OVERVIEW } from '~/basket/model/constants'
import { InjectedBasketProps } from '~/basket/view/withBasket'

import { calculateVatAmount, formattedNumber, formattedTotalPrice } from '~/basket/view/util/price'
import { zero } from '~/basket/model/utils/price'
import { useFetchSupportedPaymentMethods } from '../../pages/overview/util/useFetchSupportedPaymentMethods'
import { PaymentType } from './PaymentType'

type Props = InjectedBasketProps & {
  showTotalPrice: boolean
}

export function NavigatorDesktopShipment(props: Props) {
  const { basket, stepNavigation } = props
  const { t } = useTranslation()

  const { data: { paymentMethods } = {} } = useFetchSupportedPaymentMethods()

  // eslint-disable-next-line react/destructuring-assignment
  const price = props.showTotalPrice ? basket.totalPrice : basket.price
  const vatAmount = calculateVatAmount(price || zero)
  const vatText = vatAmount !== 0 ? `${t('including')} ${formattedNumber(vatAmount)} ${t('vat')}` : ''
  const days = basket.delivery ? basket.delivery.days : 0

  return (
    <Box position="fixed">
      <Grid container direction="column" spacing={0} alignItems="stretch" wrap="nowrap">
        <Grid>
          <Paper
            sx={(theme) => ({
              backgroundColor: theme.palette.secondary.main,
              color: '#333',
              margin: theme.spacing(2),
              padding: theme.spacing(2),
            })}
          >
            <Typography variant="h3"> {formattedTotalPrice(price || zero)} </Typography>
            <Box mt={1}>
              <Typography variant="body2">{vatText}</Typography>
              <Typography variant="body2">
                {stepNavigation.displayedStep !== OVERVIEW &&
                  days > 0 &&
                  (days > 1 ? t('deliverydays_plural', { count: days }) : t('deliverydays', { count: days }))}
              </Typography>
            </Box>
          </Paper>
        </Grid>

        {!basket.config.isParcelshopPaymentEnabled && paymentMethods && (
          <Grid>
            <Paper
              sx={(theme) => ({
                margin: theme.spacing(2),
                padding: theme.spacing(2),
              })}
            >
              {t('payment_method_notice')}
              <List className="pwa-payment-container">
                {paymentMethods.map((paymentType) => (
                  <PaymentType key={paymentType.type} paymentMethod={paymentType} />
                ))}
              </List>
            </Paper>
          </Grid>
        )}
      </Grid>
    </Box>
  )
}
